import { useEffect, useState } from "react";

const timeOptions: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

const CLOCK_CONFIGS = [
  { label: "New York", timeZone: "America/New_York" },
  { label: "Stockholm", timeZone: "Europe/Stockholm" },
  { label: "Hong Kong", timeZone: "Asia/Hong_Kong" },
  { label: "Tokyo", timeZone: "Asia/Tokyo" },
];

function formatTime(timeZone: string, date: Date) {
  return new Intl.DateTimeFormat(undefined, { ...timeOptions, timeZone }).format(date);
}

const Clocks = () => {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex space-x-4">
      {CLOCK_CONFIGS.map((clock) => (
        <div
          key={clock.label.toLowerCase()}
          className="flex flex-col md:flex-row text-sm md:space-x-2"
        >
          <span className="font-bold">{clock.label}:</span>
          <span>{now ? formatTime(clock.timeZone, now) : "00:00:00"}</span>
        </div>
      ))}
    </div>
  );
};

export default Clocks;
